import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {UserService} from "@rsp/shared/services/user.service";


@Injectable()
export class RoleGuard implements CanActivate {

  constructor( public auth: UserService, public router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if ( !this.auth.hasRole(route.data.expectedRole) ) {
      this.router.navigate(["landing"]);
      return false;
    }

    return true;
  }
}
